import FuncionarioView from "./view/funcionario.list"

export const FuncionarioList = FuncionarioView